(() => {
  const header = document.querySelector('[data-ln-header]');
  if (!header || header.dataset.ready) return;
  header.dataset.ready = 'true';
  const menus = [...header.querySelectorAll('details')];
  menus.forEach(menu => menu.addEventListener('toggle', () => { if (menu.open) menus.forEach(other => { if (other !== menu && !other.contains(menu) && !menu.contains(other)) other.open = false; }); }));
  document.addEventListener('click', event => { if (!header.contains(event.target)) menus.forEach(menu => menu.open = false); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { menus.forEach(menu => { if (menu.open) { menu.open = false; menu.querySelector('summary').focus(); } }); hideSuggestions(); } });
  const input = document.querySelector('#ln-search-input');
  const results = document.querySelector('#ln-search-results');
  let timer, request;
  const hideSuggestions = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); };
  input.addEventListener('input', () => {
    clearTimeout(timer); request?.abort();
    const query = input.value.trim();
    if (query.length < 2) { hideSuggestions(); return; }
    timer = setTimeout(async () => {
      const controller = new AbortController(); request = controller;
      try {
        const url = new URL('/search/suggest.json', location.origin);
        url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '5');
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (input.value.trim() !== query) return;
        results.replaceChildren();
        for (const product of data.resources?.results?.products || []) {
          const link = document.createElement('a');
          const target = new URL(product.url, location.origin);
          if (target.origin !== location.origin) continue;
          link.href = target.pathname + target.search;
          if (product.image) { const img = document.createElement('img'); img.src = product.image; img.alt = ''; img.width = 52; img.height = 52; link.append(img); }
          const label = document.createElement('span'); label.textContent = product.title; link.append(label); results.append(link);
        }
        const all = document.createElement('a'); all.href = '/search?type=product&q=' + encodeURIComponent(query); all.textContent = `See all results for “${query}” →`; results.append(all);
        results.hidden = false; input.setAttribute('aria-expanded', 'true');
      } catch (error) { if (error.name !== 'AbortError') hideSuggestions(); }
    }, 220);
  });
  input.addEventListener('keydown', event => { if (event.key === 'ArrowDown' && !results.hidden) { event.preventDefault(); results.querySelector('a')?.focus(); } });
  document.addEventListener('click', event => { if (!event.target.closest('[data-ln-search]')) hideSuggestions(); });
  const film = document.querySelector('[data-ln-hero-video]');
  const pause = document.querySelector('[data-ln-pause]');
  if (film && pause) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { film.pause(); pause.hidden = true; }
    pause.addEventListener('click', async () => {
      if (film.paused) { try { await film.play(); pause.textContent = 'Pause film Ⅱ'; pause.setAttribute('aria-label', 'Pause background video'); } catch {} }
      else { film.pause(); pause.textContent = 'Play film ▷'; pause.setAttribute('aria-label', 'Play background video'); }
    });
  }
  const panel = document.querySelector('[data-ln-comparison]');
  const items = document.querySelector('[data-ln-compare-items]');
  let shortlist = [];
  try { const saved = JSON.parse(sessionStorage.getItem('lumira-shortlist-v1') || '[]'); if (Array.isArray(saved)) shortlist = saved.filter(p => typeof p.title === 'string' && /^\/products\//.test(p.url)).slice(0,3); } catch {}
  function renderComparison() {
    if (!panel) return;
    panel.hidden = !shortlist.length; items.replaceChildren(); document.querySelector('[data-ln-compare-count]').textContent = `${shortlist.length}/3`;
    shortlist.forEach(product => {
      const row = document.createElement('div'), img = document.createElement('img'), content = document.createElement('div'), link = document.createElement('a'), price = document.createElement('strong'), remove = document.createElement('button');
      if (/^(https:)?\/\//.test(product.image || '')) { img.src = product.image; img.alt = ''; row.append(img); }
      link.href = product.url; link.textContent = product.title; price.textContent = product.price; remove.textContent = 'Remove'; remove.type = 'button'; remove.setAttribute('aria-label', `Remove ${product.title} from comparison`);
      remove.addEventListener('click', () => { shortlist = shortlist.filter(p => p.id !== product.id); renderComparison(); });
      content.append(link,price,remove); row.append(content); items.append(row);
    });
    document.querySelectorAll('[data-ln-compare]').forEach(button => { const added = shortlist.some(p => p.id === button.dataset.id); button.textContent = added ? '✓ In your shortlist' : '＋ Compare'; button.setAttribute('aria-pressed', String(added)); });
    try { sessionStorage.setItem('lumira-shortlist-v1', JSON.stringify(shortlist)); } catch {}
  }
  document.querySelectorAll('[data-ln-compare]').forEach(button => button.addEventListener('click', () => {
    if (shortlist.some(p => p.id === button.dataset.id)) shortlist = shortlist.filter(p => p.id !== button.dataset.id);
    else if (shortlist.length < 3) shortlist.push({...button.dataset});
    else { document.querySelector('[data-ln-notice]').textContent = 'Your shortlist has three pieces. Remove one to compare another.'; return; }
    document.querySelector('[data-ln-notice]').textContent = ''; renderComparison();
  }));
  document.querySelector('[data-ln-clear]')?.addEventListener('click', () => { shortlist = []; renderComparison(); });
  renderComparison();
})();
